import { IndexCardStack } from './index-card-stack';
import { Type } from '@angular/core';
import { GlassHouseBrandGroupIndexCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/index-cards-3x5/glass-house-brand-group-index-card-stack-content/glass-house-brand-group-index-card-stack-content.component';
import { GlassHouseBrandGroupIndexCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/index-cards-3x5/glass-house-brand-group-index-card-stack-background/glass-house-brand-group-index-card-stack-background.component';
import type { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import type { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import type { GlassHouseBrandGroupCardData } from '../../../../print-cards/glass-house/glass-house-brand-group-card-data';

export class GlassHouseIndexCardStack extends IndexCardStack {
  getCardBackgroundComponent(cardData: GlassHouseBrandGroupCardData): Type<CardBackgroundComponent> {
    return GlassHouseBrandGroupIndexCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: GlassHouseBrandGroupCardData): Type<PrintCardContentComponent> {
    return GlassHouseBrandGroupIndexCardStackContentComponent;
  }

  override nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
